import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c36b7b34")

_pushScopeId("data-v-c36b7b34")
const _hoisted_1 = { class: "reports__text" }
const _hoisted_2 = { class: "reports__text-name" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "reports__text-date" }, null, -1)
const _hoisted_4 = { class: "swiper-control" }
const _hoisted_5 = {
  ref: "prev",
  class: "btn swiper-button-next"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.7124 8.30001L6.42907 5.58335C6.7499 5.26251 6.7499 4.73751 6.42907 4.41668L3.7124 1.70001",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = {
  ref: "next",
  class: "btn swiper-button-prev"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.7124 8.30001L6.42907 5.58335C6.7499 5.26251 6.7499 4.73751 6.42907 4.41668L3.7124 1.70001",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock("div", {
    class: "frequently-reports",
    onKeyup: _cache[1] || (_cache[1] = (...args) => ($setup.swiperKey(...args))),
    onKeydown: _cache[2] || (_cache[2] = (...args) => ($setup.swiperKey(...args)))
  }, [
    _createVNode(_component_swiper, {
      "slides-per-view": $setup.perSlide,
      "space-between": 24,
      navigation: {
        prevEl: $setup.prev,
        nextEl: $setup.next
      },
      onSwiper: $setup.getRef
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.reports, (report) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: report.id
          }, {
            default: _withId(() => [
              _createVNode(_component_router_link, {
                to: {
            name: 'statisticsResult',
            params: {
              newBulletinId: report.id,
              categoryId: report.report_category_id,
              newBulletinName: $setup.getStatTreeName(report) || report.name
            }
          },
                class: "reports"
              }, {
                default: _withId(() => [
                  _createVNode("img", {
                    class: "reports__photo",
                    src: require('@/assets/images/' + report.image),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_1, [
                    _createVNode("p", _hoisted_2, _toDisplayString($setup.getStatTreeName(report) || report.name), 1),
                    _hoisted_3
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1024))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode("div", _hoisted_4, [
          _createVNode("button", _hoisted_5, [
            _hoisted_6
          ], 512),
          _createVNode("button", _hoisted_7, [
            _hoisted_8
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["slides-per-view", "navigation", "onSwiper"])
  ], 32))
})